import React from "react";
import LegalDocumentPage from "./LegalDocumentPage";
import { TERMS_OF_USE_DOCUMENT } from "../content/legalDocuments";

export default function TermsOfUsePage() {
  return <LegalDocumentPage document={TERMS_OF_USE_DOCUMENT} />;
}
